<p-toast></p-toast>
<!-- <p-tabMenu [model]="items" [activeItem]="items[0]" class="mb-4">
</p-tabMenu> -->

<div class="tabmenu-wrapper" style="position: relative; width: 100%;">
  <p-tabMenu [model]="items" [activeItem]="items[0]" class="mb-2 full-tabmenu"></p-tabMenu>

  <!-- Right-side button inside tab menu container -->
  <!-- <button 
    pButton 
    pRipple 
    label="{{'Area' | translate}}"
    icon="pi pi-map-marker" 
    class="p-button-success area-button"
    (click)="openGeoMappingPopup()">
  </button> -->
</div>




<!-- 🗺️ Area Mapping Dialog -->
<p-dialog
  [(visible)]="showGeoDialog"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '75vw', maxWidth: '950px' }"
  [contentStyle]="{
    'background-color': '#f3f4f6',
    'overflow': 'hidden',
    'padding': '0.5rem 1rem'
  }"
  styleClass="geo-dialog"
  (onHide)="onGeoDialogClose()"
>
  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="header-container">
      <i class="pi pi-map-marker header-icon"></i>
      <h3 class="header-title">
        Assigned Areas For :
        <strong>{{ userID }}</strong>
      </h3>
    </div>
  </ng-template>

  <!-- Table Content -->
  <ng-container *ngIf="filteredGeoMappings.length; else noData">
    <p-card styleClass="p-card-shadow" class="dashboardTable">
      <p-table
        [value]="filteredGeoMappings"
        [rows]="10"
        [paginator]="true"
        [loading]="loading"
        [rowHover]="true"
        [scrollable]="true"
        scrollHeight="250px"
        dataKey="userID"
        responsiveLayout="scroll"
        [tableStyle]="{ 'min-width': '100%' }"
        currentPageReportTemplate="{{ 'SHOWING' | translate }} {first} {{ 'TO' | translate }} {last} {{ 'OF' | translate }} {totalRecords} {{ 'ENTRIES' | translate }}"
        [showCurrentPageReport]="true"
        styleClass="custom-geo-table"
      >
        <!-- Header -->
        <ng-template pTemplate="header">
          <tr style="background-color: #374151; color: white; text-align: center">
            <th>Officer Name</th>
            <th>Area</th>
           
            <th>Area Type</th>
            <th>Action</th>
          </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr
            class="transition-colors duration-150 cursor-pointer"
            [ngStyle]="{
              'background-color': hoveredRow === i ? '#95d5b2' : '',
              'color': hoveredRow === i ? '#000' : ''
            }"
            (mouseenter)="hoveredRow = i"
            (mouseleave)="hoveredRow = -1"
          >
            <td class="text-center">{{ row.officer_Name }}</td>
            <td class="text-center">{{ row.geoName }}</td>
       
            <td class="text-center">{{ row.geoType }}</td>
            <td class="text-center text-sm text-gray-700">{{ row.action }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </ng-container>

  <!-- No Data -->
  <ng-template #noData>
    <p class="text-center mt-3 text-gray-600">
      No areas assigned for {{ userID }} ({{ userRole }}).
    </p>
  </ng-template>
</p-dialog>




<router-outlet></router-outlet>
